import { loadEvents, loadEvent, loadEventMembers, addContactsToEvent, removeContactsFromEvent, createEvent } from '../common/api';

const events = {
    name: 'events',
    state: { 
        names: [], 
        current: {
            details: {},
            members: []
        },
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.eid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.eid]: { ...payload.cdc }
                }
            }
        },
        cdcInsertMember: ( state, payload ) => {
            const [ eid, oid ] = payload.eid.split( '#' );
            const event = state.byId[eid];
            if ( !event?.members ) {
                event['members'] = [];
            }
            event.members.push( payload.cdc );
            
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [eid]: { 
                        ...event,
                        count: event.members.length 
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.eid]: {
                        ...state.byId[payload.eid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.eid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        cdcRemoveMember: ( state, payload ) => {
            const [ eid, cid ] = payload.eid.split( '#' );
            const event = state.byId[eid];
            const members = event.members.filter( f => f.cid !== cid );
            
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [eid]: {
                        ...state.byId[eid],
                        members: members,
                        count: members.length
                    }
                }
            }
        },
        loadedEventsById: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        },
        loadedEvents: ( state, payload ) => {
            return {
                ...state,
                names: payload
            }
        },
        loadedEvent: ( state, payload ) => {
            return {
                ...state,
                current: {
                    ...state.current,
                    details: payload
                }
            }
        },
        loadedEventMembers: ( state, payload ) => {
            return {
                ...state,
                current: {
                    ...state.current,
                    members: payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadEvent( { aid, uid, eid } ) {
            const e = await loadEvent( aid, uid, eid );
            dispatch.events.loadedEvent( e );
        },
        async loadEventMembers( { aid, uid, eid } ) {
            const e = await loadEventMembers( aid, uid, eid );
            dispatch.events.loadedEventMembers( e );
        },
        async addContactsToEvent( { aid, uid, eid, contacts } ) {
            const e = await addContactsToEvent( aid, uid, eid, contacts );
            return e;
        },
        async createEvent( { aid, uid, event, contacts } ) {
            const e = await createEvent( aid, uid, event, contacts );
            return e;
        },
        async loadEvents( { aid, uid } ) {
            const list = await loadEvents( aid, uid );
            let byId = {};
            list.forEach( l => byId[l.eid] = l );
            dispatch.events.loadedEventsById( byId );
        },
        insert( { eid, cdc } ) {
            const member = eid.match( '#' );
            if ( member ) {
                dispatch.events.cdcInsertMember( { eid, cdc } );
            } else {
                dispatch.events.cdcInsert( { eid, cdc } );
            }
        },
        modify( { eid, cdc } ) {
            dispatch.events.cdcModify( { eid, cdc } );
        },
        remove( { eid } ) {
            const member = eid.match( '#' );
            if ( member ) {
                dispatch.events.cdcRemoveMember( { eid } );
            } else {
                dispatch.events.cdcRemove( { eid } );
            }
        },
        setCurrent( { eid } ) {
            dispatch.events.setCurrentId( { eid } );
        }
    } )
}

export default events;